import PcMain from '@/components/pc/Main/Main';
import MobileMain from '@/components/mo/Main/Main';
import { useIsMobile } from '@/hooks/useIsMobile';
import { Spin } from 'antd';
import styled from 'styled-components';

const Main = () => {
  const isMobile = useIsMobile();

  if (isMobile === null) {
    return (
      <SpinnerWrapper>
        <Spin size="large" />
      </SpinnerWrapper>
    );
  }

  return isMobile ? <MobileMain /> : <PcMain />;
};

export default Main;

// ✅ 중앙 정렬 스피너 스타일
const SpinnerWrapper = styled.div`
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;
